'use client';

import { useCallback, useRef, useState } from 'react';

import type { GameState } from '@/app/(football)/[team]/mini-game/_components/Section/GameSection/BlockStackingGame/types';

/**
 * Game state management hook
 * Manages overall game state and score
 */
export function useGameState() {
  const [score, setScore] = useState(0);
  const [gameState, setGameState] = useState<GameState>('loading');

  const autopilotRef = useRef(true);
  const gameEndedRef = useRef(false);
  const robotPrecisionRef = useRef(0);

  const setRobotPrecision = useCallback(() => {
    robotPrecisionRef.current = Math.random() * 1 - 0.5;
  }, []);

  const resetGameState = useCallback(() => {
    autopilotRef.current = true;
    gameEndedRef.current = false;
    setRobotPrecision();
    setScore(0);
  }, [setRobotPrecision]);

  const startGame = useCallback(() => {
    autopilotRef.current = false;
    gameEndedRef.current = false;
    setScore(0);
    setGameState('playing');
  }, []);

  const endGame = useCallback(() => {
    gameEndedRef.current = true;
    if (!autopilotRef.current) {
      setGameState('gameOver');
    }
  }, []);

  return {
    score,
    gameState,
    autopilotRef,
    gameEndedRef,
    robotPrecisionRef,
    setScore,
    setGameState,
    setRobotPrecision,
    resetGameState,
    startGame,
    endGame,
  };
}
